import React, { useState, useRef } from 'react';
import { Upload, RefreshCw } from 'lucide-react';
import { authAxios, apiErrorMessage } from '@/lib/api';

const VIDEO_EXTS = ['mp4', 'webm', 'mov'];

export default function VideoDropZone({ onUpload }) {
  const [dragging, setDragging] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState('');
  const fileRef = useRef(null);

  const handleFile = async (file) => {
    if (!file) return;
    const ext = file.name.split('.').pop().toLowerCase();
    if (!VIDEO_EXTS.includes(ext)) {
      alert('Only MP4, WebM, and MOV video files are supported.');
      return;
    }
    setUploading(true);
    setProgress(`Uploading ${file.name}...`);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const { data } = await authAxios.post('/api/upload', formData);
      onUpload(data.url);
    } catch (e) {
      alert('Video upload failed: ' + apiErrorMessage(e));
    } finally {
      setProgress('');
      setUploading(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    handleFile(e.dataTransfer.files[0]);
  };

  return (
    <div
      className={`border-2 border-dashed rounded-lg p-4 text-center transition-colors ${dragging ? 'border-saffron bg-saffron/5' : 'border-earth/20 hover:border-saffron/40'}`}
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={handleDrop}
      data-testid="video-dropzone"
    >
      <input ref={fileRef} type="file" accept="video/mp4,video/webm,video/quicktime,.mp4,.webm,.mov" className="hidden" onChange={(e) => handleFile(e.target.files[0])} data-testid="video-file-input" />
      {uploading ? (
        <div className="flex items-center justify-center gap-2 py-1">
          <RefreshCw size={14} className="animate-spin text-saffron" />
          <span className="text-xs font-sans text-saffron">{progress}</span>
        </div>
      ) : (
        <>
          <button type="button" onClick={() => fileRef.current?.click()} className="text-xs font-sans text-saffron hover:text-saffron-dark transition-colors flex items-center gap-1.5 mx-auto" data-testid="video-upload-btn">
            <Upload size={13} /> Drag & drop video or click to upload
          </button>
          <p className="text-[10px] text-earth/30 font-sans mt-1">Supports MP4, WebM, MOV files</p>
        </>
      )}
    </div>
  );
}
